import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <ul className="greenbullet-list">
                                                <li>Provide a timescale for each task.</li>
                                                <li>Identify how each task will be done and by whom.</li>
                                                <li>Translate your timeframe into calendar dates.</li>
                                                <li>Allow for contingencies. If you schedule tasks too closely
                                                    you’ll have no leeway if things slip
                                                    a little.
                                                </li>
                                                <li>Be flexible – your plan may need to alter during the
                                                    project’s course.
                                                </li>
                                                <li>Update your project plan. Record when each deliverable is
                                                    completed.
                                                </li>
                                            </ul>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <p>
                                                    Once you’ve got your plan sorted, a Gantt chart<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>5</sup></a> is a
                                                    great, quick visual reference. It’ll help
                                                    you stick to your timeframes and identify the knock-on
                                                    effects of any missed deadlines,
                                                    immediately.
                                                </p>
                                            </div>
                                            <div className="mobile-scroll" style={{height: 'auto'}}>
                                                <table className="ilead_v_sport tablesrink" border="0"
                                                       cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve " align="left" valign="top"
                                                            width="3%"></th>
                                                        <th align="left" valign="top" width="15%"
                                                            colSpan="2">Week 1
                                                        </th>
                                                        <th align="left" valign="top" width="15%"
                                                            colSpan="2">Week 2
                                                        </th>
                                                        <th align="left" valign="top" width="15%"
                                                            colSpan="2">Week 3
                                                        </th>

                                                        <th className=" green_curve1" align="left" valign="top"
                                                            width="15%" colSpan="2">Week 4
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">Task 1
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#538F9F'}}></td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#538F9F'}}>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">Task 2
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%"></td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#69B0C5'}}>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">Task 3
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%"></td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#7CACB9'}}>
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#7CACB9'}}>
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#7CACB9'}}>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">Task 4
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%"></td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#90C5D4'}}>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">Task 5
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%"></td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#ADCDD5'}}>
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#ADCDD5'}}>
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#ADCDD5'}}>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">Task 6
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%"></td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#BBDDE6'}}>
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#BBDDE6'}}>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">Task 7
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%"></td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#D2E3E9'}}>
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#D2E3E9'}}>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">Task 8
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%"></td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#538F9F'}}>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">Task 9
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%"></td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#69B0C5'}}>
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#69B0C5'}}>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">Task 10
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%"></td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="3%">
                                                        </td>
                                                        <td className="" align="left" valign="top" width="3%"
                                                            style={{backgroundColor: '#7CACB9'}}>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="border_subtitle">Meetings</div>
                                            <p>Hold regular meetings with key stakeholders to update and discuss
                                                any changes in objectives,
                                                priorities and timeframes. Hold weekly meetings with the project
                                                team to check the progress and
                                                timeliness of each task. Check everyone’s managing his or her
                                                workload and re-distribute tasks
                                                to maintain momentum, if appropriate.</p>
                                            <div className="border_subtitle">Risk management</div>
                                            <div className="uiheading"><p>Take time to identify potential risks
                                                before the project starts. For each task involved, consider:
                                            </p></div>

                                            <div className="lightgreencontentbg keyquestionpad lightbgui1">
                                                <ul className="greenbullet-list ">
                                                    <li>What are the risks?</li>
                                                    <li>How likely are they?</li>
                                                    <li>If they did happen, what are the implications?</li>
                                                    <li>What can you do to minimise them?</li>
                                                </ul>

                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}